import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const API = process.env.REACT_APP_BACKEND_URL;

export const buildDepositSms = (firstName, ticket, count, estimatedDate) => {
  let msg = `Pressing Sakura: Bonjour ${firstName}, nous avons bien recu vos ${count} article(s)`;
  if (ticket) msg += ` (ticket n°${ticket})`;
  if (estimatedDate) msg += `. Retour prevu le ${new Date(estimatedDate).toLocaleDateString("fr-FR")}`;
  return msg + ". Merci !";
};

export const DepositSavedModal = ({ deposit, phone, initialMessage, getAuth, onClose }) => {
  const [message, setMessage] = useState(initialMessage);
  const [sending, setSending] = useState(false);

  const sendSms = async () => {
    const headers = getAuth();
    if (!headers) return;
    setSending(true);
    try {
      await axios.post(`${API}/api/admin/deposit-slip/${deposit.id}/sms`, { message }, { headers });
      toast.success("SMS envoyé !");
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi du SMS");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="deposit-saved-modal">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl space-y-4">
        <div className="text-center">
          <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-2" />
          <h3 className="text-xl font-bold text-slate-800">Bon de dépôt enregistré</h3>
          <p className="text-sm text-slate-500">Il est visible dans la fiche du client.</p>
        </div>
        <div>
          <p className="text-sm font-medium mb-1">Message SMS {phone ? `(${phone})` : ""}</p>
          <Textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={4} data-testid="deposit-sms-message" />
          {!phone && <p className="text-xs text-amber-600 mt-1">Ce client n'a pas de numéro de téléphone.</p>}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <Button type="button" variant="outline" className="h-12" onClick={onClose} data-testid="deposit-saved-close-btn">
            Fermer
          </Button>
          <Button type="button" className="h-12 bg-green-600 hover:bg-green-700" disabled={!phone || sending || !message.trim()} onClick={sendSms} data-testid="deposit-send-sms-btn">
            <MessageSquare className="w-5 h-5 mr-2" />
            {sending ? "Envoi..." : "Envoyer SMS"}
          </Button>
        </div>
      </div>
    </div>
  );
};
